import React from 'react';
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import SubAdminSideBar from '../SubAdminSideBar';
import UserRoles from '../UserRoles';

const UserRoleSubAdminPage = () => {
  return (
    <React.Fragment>
    <SubAdminSideBar>
       <UserRoles />
    </SubAdminSideBar>
  </React.Fragment>
  );
}

export default NetworkDetector(UserRoleSubAdminPage);

